import { useLocalStorage, useMedia } from "react-use";
import { createContainer } from "unstated-next";

function usePageNavState() {
  const [storedCollapsed, setCollapsed] = useLocalStorage(
    "page-nav-collapse",
    false,
  );
  const isMobile = useMedia("(max-width: 600px)");
  const collapsed = isMobile || storedCollapsed;

  return { collapsed, setCollapsed };
}

export const PageNavState = createContainer(usePageNavState);
